const advertise = {
    dfdh: 'Karşı Taraf Telefon:',
    sjmc: 'Satıcı Adı',
    qsrsj: 'Lütfen satıcı adını girin',
    sjbzj: 'Satıcı Teminatı',
    wcl: '30 Gün Tamamlama Oranı',
    zcd: 'Toplam İşlem (Al/Sat)',
    cd: '30 Günlük İşlem',
    c: 'kez',
    fz: 'dakika',
    pjfx: 'Ortalama Serbest Bırakma Süresi',
    zcsj: 'Kayıt Tarihi:',
    fbjy: 'İlk Para Birimi İşlemi Ziyareti:',
    yxbd: 'E-posta Bağlı',
    sjbd: 'Telefon Bağlı',
    cjsm: 'Temel Kimlik Doğrulama',
    gjsm: 'Gelişmiş Kimlik Doğrulama',
    buy: 'Satın Al',
    sell: 'Sat',
    market: 'Piyasa',
    djfs: 'Fiyatlandırma Yöntemi',
    ggid: 'Reklam ID',
    time: 'Zaman',
    type: 'Tür',
    ptgg: 'Normal Reklam',
    gdjg: 'Sabit Fiyat',
    fdjg: 'Değişken Fiyat',
    yjfw: 'Prim Aralığı',
    unitPrice: 'Birim Fiyat',
    totalPrice: 'Toplam Fiyat',
    sysl: 'Kalan Miktar',
    ywcsl: 'Tamamlanan Miktar',
    cz: 'İşlem',
    xj: 'Yayından Kaldır',
    sj: 'Yayınla',
    edit: 'Düzenle',
    delete: 'Sil',
    all: 'Tümü',
    qdxjm: 'Bu reklamı yayından kaldırmak istediğinize emin misiniz?',
    qdxj: 'Yayından Kaldırma Onayı',
    qdsjm: 'Bu reklamı yayınlamak istediğinize emin misiniz?',
    qdsj: 'Yayınlama Onayı',
    confirm: 'Onayla',
    cancel: 'İptal',
    qdscm: 'Bu reklamı silmek istediğinize emin misiniz?',
    deleteAdvertise: 'Reklamı Sil',

    tjgm: 'Satın Alma İstatistiği',
    tjcs: 'Satış İstatistiği',
    coins: 'Para Birimi',
    day7: '7 Gün',
    day15: '15 Gün',
    day30: '30 Gün',
    tj: 'İstatistik',
    mrsl: 'Alım Miktarı',
    mcsl: 'Satış Miktarı',
    mrjj: 'Ortalama Alım Fiyatı',
    mcjj: 'Ortalama Satış Fiyatı',
    zcje: 'Toplam Harcama',
    srje: 'Toplam Gelir',
    zsxf: 'Toplam İşlem Ücreti',
    cjdd: 'Gerçekleşen Siparişler',
    zdxx: 'Fatura Bilgisi',
    tips: 'İpucu: Her işlem çifti için alım ve satım istatistikleri günde sadece 100 kez dışa aktarılabilir',
    dcdd: 'Siparişleri Dışa Aktar',
    orderNo: 'Sipariş No',
    jybz: 'İşlem Para Birimi',
    number: 'Miktar',
    total: 'Toplam',
    fee: 'Ücret',
    zd: 'Fatura',

    tjskfs: 'Ödeme Yöntemi Ekle',
    skfs: 'Ödeme Yöntemi',
    name: 'Ad',
    payAccount: 'Hesap',
    sk: 'Ödeme',
    cz: 'İşlem',
    delete: 'Sil',
    edit: 'Düzenle',
    qdsc: 'Silmeyi onaylıyor musunuz?',
    tip: 'İpucu',
    deleted: 'Silme iptal edildi',
    xzskfstt: 'Yeni Ödeme Yöntemi Ekle',
    xgskfstt: 'Ödeme Yöntemini Düzenle',
    khmc: 'Hesap Sahibi Adı',
    yhkh: 'Banka Kartı Numarası',
    khh: 'Banka',
    khhszd: 'Banka Şubesi Konumu',
    khhmc: 'Banka Adı',
    wxzh: 'WeChat Hesabı',
    zfbzf: 'Alipay Ödeme',
    ewmsc: 'QR Kodu Yükle',
    jymm: 'İşlem Şifresi',
    srkhh: 'Lütfen banka adını girin',
    xzszd: 'Lütfen banka şubesinin konumunu seçin',
    srkhmc: 'Lütfen banka adını girin',
    srzh: 'Lütfen hesap numarasını girin',
    scskm: 'Lütfen ödeme kodunu yükleyin',
    srjymm: 'Lütfen işlem şifresini girin',
    scwjgd: 'Yüklenen profil resmi 2MB\'dan büyük olamaz!',

    jnbzj1: '{gradeName} olarak, {margin} USDT teminat ödediniz, mevcut kalan reklam limitiniz {amount} USDT',
    k: 'Mevcut',
    add: 'Ekle',
    or: 'veya',
    reduce: 'Azalt',
    margin: 'Teminat',
    sqsxf: '*Platform, satıcılardan reklam işlem hacminin {fee}%\'unu işlem ücreti olarak alacaktır',
    hqed: 'Hemen onaylı satıcı olarak daha yüksek limitler elde edin',
    want: 'İstediğim',
    bb: 'Coin-Coin',
    price: 'Fiyat',
    ckj: '*Piyasa referans fiyatı {price} {fiatCurrency}/USDT. Sabit fiyat piyasa dalgalanmalarından etkilenmez',
    jyjg: 'İşlem Fiyatı',
    mdjg: 'Çapa Fiyatı',
    gxhl: '*Çeşitli banka ve borsaların gerçek zamanlı döviz kurları entegre edilmiştir, her 5 dakikada bir güncellenir',
    szyj: 'Prim Ayarla',
    zjjy: '*Negatif girilebilir, bu çapa fiyatı üzerinden indirimli işlem anlamına gelir',
    yjsz: '*İşlem Fiyatı = Çapa Fiyatı * (1 + Prim Ayarı)',
    jyxz: 'İşlem Kısıtlamaları',
    jysl: 'İşlem Miktarı',
    sygged: '*İşlem miktarı mevcut kalan reklam limitini aşamaz',
    zxxe: 'Minimum Tek İşlem Limiti',
    zdxe: 'Maksimum Tek İşlem Limiti',
    fkqx: 'Ödeme Süresi',
    xnfk: '*Bu süre içinde ödeme yapılmalıdır',
    fkfs: 'Ödeme Yöntemi',
    xzskfs: '*Tüm para birimleri için en fazla 5 ödeme yöntemi eklenebilir',
    yhjy: 'Gelişmiş kimlik doğrulamasını tamamlamamış kullanıcılarla işlem yapma',
    jygg: '*Sadece temel kimlik doğrulamasını tamamlamış kullanıcılar işlem reklamlarına giremez',
    cyjy: 'Lütfen belirli satın alma sayısını tamamlamamış kullanıcıları seçin, bu kullanıcılar işleme katılamaz',
    bmfx: '*Daha önce satın alma işlemi tamamlamış kullanıcılar, kaynağı belirsiz fon riskini büyük ölçüde azaltmıştır',
    qxz: 'Lütfen seçin',
    jybz: 'İşlem Açıklaması',
    tyzs: 'Öğrendim ve kabul ediyorum',
    jygz: '《İşlem Kuralları》',
    yzm: 'Doğrulama Kodu',
    save: 'Kaydet',
    fbgg: 'Reklam Yayınla',
    jsbzjcg: 'Teminat azaltma başarılı',
    zjbzjcg: 'Teminat ekleme başarılı',
    xzfs: 'Lütfen ödeme yöntemi veya ödeme şekli seçin',
    bankTip1: 'Banka kartı için en fazla üç ödeme yöntemi',
    wxTip2: 'WeChat için en fazla üç ödeme yöntemi',
    zfbTip3: 'Alipay için en fazla üç ödeme yöntemi',
    syjg: 'Lütfen fiyat girin',
    syjysl: 'Lütfen işlem miktarını girin',
    zxxe: 'Lütfen minimum tek işlem limitini girin',
    zdxe: 'Lütfen maksimum tek işlem limitini girin',
    fkqx: 'Lütfen ödeme süresini girin',
    tyjygz: 'Lütfen işlem kurallarını kabul edin',
    tpyzm: 'Lütfen resimdeki doğrulama kodunu girin',
    jydx: 'İşlem Hedefi',

    zjbzj: 'Teminat Ekle',
    jsbzj: 'Teminat Azalt',
    xzdgged: 'Mevcut Maksimum Reklam Limiti',
    zjbzjse: 'Eklenecek Teminat Miktarı',
    jsbzjse: 'Azaltılacak Teminat Miktarı',
    zjhbzjed: 'Ekleme Sonrası Teminat Limiti',
    jshbzjed: 'Azaltma Sonrası Teminat Limiti',
    balance: 'Bakiye',
    sy: 'Kalan',
    kzj: 'Eklenebilir',
    kjs: 'Azaltılabilir',
    otcsjxy: 'OTC Satıcı Hizmet Kuralları Anlaşması',
    xsgz: 'Yeni Başlayanlar İçin Eğitim',
    jygz: 'İşlem Kuralları',
    jnbzj: "OTC'nin yasal ve uyumlu olmasını, ilgili tarafların davranışlarını düzenlemek için satıcıların belirli bir miktarda teminat ödemesi gerekmektedir; ",
    zjjnbzj: 'Teminat, temel limit ve ek limit olarak iki kısımdan oluşur. Temel limit zorunludur, ek kısım isteğe bağlıdır;',
    kxs: 'Temel limit ödemesi şu avantajı sağlar:',
    fbgged: 'CNYT yayınlarken döviz kuru üzerinden hesaplanır) reklam limiti;',
    ggedbl: 'Ek kısım teminat ile reklam limiti oranı',
    eg: 'Örneğin 100 USDT eklendiğinde, reklam limiti temel limit üzerine 100 x kadar artar',
    ggzedjs: 'Toplam reklam limiti formülü: Temel reklam limiti + Ek reklam limiti x',
    ttsjzxed: 'Normal satıcılar için minimum ek teminat miktarı',
    zdedw: 'Maksimum miktar',
    mgsjzd: 'Her satıcı en fazla üç alım reklamı ve üç satış reklamı yayınlayabilir.',
    hljj: 'USDT/CNYT döviz kuru, BiKing platformundaki ilgili işlem çiftinin son 24 saatlik ortalama fiyatından (saatlik kayıt alınır ve en yüksek/en düşük fiyatlar çıkarılır) alınır ve mevcut döviz kuru olarak kullanılır; döviz kurunda dalgalanma olsa bile, önceden yayınlanan reklam limitleri aynı kalır.',
    jcbzj: 'Temel Teminat',
    xt: 'İsteğe Bağlı',
    njhded: 'Alacağınız reklam limiti:',
    mbye: 'Coin Satın Alma Bakiyesi:',
    zhzcbz: 'Hesap bakiyesi yetersiz, Varlık hesabından transfer yapabilirsiniz',
    qhz: 'Transfer Yap',
    qdjnbzj: 'Temel Teminatı Ödemeyi Onayla',
    tjbzj: 'Teminat Ekle',
    sqsjcg: 'Satıcı başvurusu başarılı',
    exchange: 'Döviz Kuru Değiştir'
}
export {
    advertise
}


// WEBPACK FOOTER //
// ./src/i18n/lang/advertise/tr.js